export const OrderStatus = {
    INCOMING: 'incoming',
    EXPORTED: 'exported',
    IN_WORK: 'in_work',
};